import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M6.31 4.839a.25.25 0 0 1 .353-.027l3.5 2.998a.25.25 0 0 1 0 .38l-3.5 3.001a.25.25 0 1 1-.326-.38l3.279-2.81-3.279-2.81a.25.25 0 0 1-.027-.352",
		clipRule: "evenodd"
	})
});
export default SvgCaretRight;
